'use client';

import { useEffect } from 'react';

import { usePathname } from 'next/navigation';

// Dynamically imports the analytics module in the effect to keep it (and isbot)
// out of the initial bundle. usePathname, not useSearchParams, so the static
// article pages aren't opted into dynamic rendering.
export function AnalyticsProvider() {
  const pathname = usePathname();

  useEffect(() => {
    let cancelled = false;
    void import('@/lib/analytics').then((analytics) => {
      if (!cancelled) analytics.firePageView();
    });
    return () => {
      cancelled = true;
    };
  }, [pathname]);

  return null;
}
